// extracted by mini-css-extract-plugin
export var wrapper = "section-community-links-module--wrapper--2G6KV";
export var body = "section-community-links-module--body--1c99x";
export var cardsWrapper = "section-community-links-module--cards-wrapper--2-lgR";